import { CardPopup, useCardPopup } from './CardPopup';
CardPopup.useCardPopup = useCardPopup;
export default CardPopup;
